import { render, staticRenderFns } from "./commonTab.vue?vue&type=template&id=0414b2b5&"
import script from "./commonTab.vue?vue&type=script&lang=js&"
export * from "./commonTab.vue?vue&type=script&lang=js&"
import style0 from "./commonTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports